export default {"src":"/_next/static/media/unbind.0f6752e1.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};